import React, { Component } from 'react'
import Aries from '../img/zodiac/aries.jpg'
import Taurus from '../img/zodiac/taurus.jpg'
import Gemini from '../img/zodiac/gemini.jpg'
import Cancer from '../img/zodiac/cancer.jpg'
import Leo from '../img/zodiac/leo.jpg'
import Virgo from '../img/zodiac/virga.jpg'
import Libra from '../img/zodiac/libra.jpg'
import Scorpio from '../img/zodiac/scorpio.jpg'
import Sagittarius from '../img/zodiac/saggitarius.jpg'
import Capricorn from '../img/zodiac/capricon.jpg'
import Aquarius from '../img/zodiac/aquarius.jpg'
import Pisces from '../img/zodiac/pieces.jpg'
import M from 'materialize-css/dist/js/materialize.min.js'

export class ZodiacSelector extends Component {
    state = {
        data:[
            {icon:{Aries},title:'Aries'},{icon:{Taurus},title:'Taurus'},{icon:{Gemini},title:'Gemini'},
            {icon:{Cancer},title:'Cancer'},{icon:{Leo},title:'Leo'},{icon:{Virgo},title:'Virgo'}
            ,{icon:{Libra},title:'Libra'},{icon:{Scorpio},title:'Scorpio'},{icon:{Sagittarius},title:'Sagittarius'}
            ,{icon:{Capricorn},title:'Capricorn'} ,{icon:{Aquarius},title:'Aquarius'} ,{icon:{Pisces},title:'Pisces'}
        ]
    }
    componentDidMount(){
        var elems = document.querySelectorAll('select');
        M.FormSelect.init(elems, {});
    }

    render() {
        const {data} = this.state;
        const {handleChange} = this.props;
        let id=0;
        return (
            <div>
                 <select id="zodiacId" defaultValue="0"  className="icons" onChange={handleChange} >
                        <option value="0" disabled>Choose your option</option>
                         {data.length && data.map((option)=>{
                             ++id
                             return <option key={id} value={id} data-icon={option.icon[option.title]} className="left">{option.title}</option>
                         })}
                 </select>
            </div>
        )
    }
}

export default ZodiacSelector
